import { TransactionsAPI } from '../api/TransactionsApi';

export const TransactionRepository = {
  validate: (contextData, transactionsData) => TransactionsAPI.validate(contextData, transactionsData)
};